export const UPLOAD_FILE_STEP = 0;
export const MATCH_FILE_FIELDS_STEP = 1;

export const FG_FIELD_MATCHER_CARD_TYPE = 0;
export const COMPONENT_FIELD_MATCHER_CARD_TYPE = 1;
